module.exports = __webpack_public_path__ + "static/media/10-1.2ab67c09.webp";